// Totem material images: one PNG per material name listed in totems.json,
// bundled from src/map/totem-materials/ (canonical; mobile syncs a copy to
// assets/totems/materials/ via `make totems-sync`, guarded in CI). Materials
// are DATA — new ones are added by dropping a PNG (or uploading through the
// /editor/ dev page), never by writing painter code.

/** Style-image name for a material: totem-tex-brick, totem-tex-dirt, … */
export function totemTextureImage(name: string): string {
  return `totem-tex-${name}`;
}

const materialUrls = import.meta.glob('./totem-materials/*.png', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>;

/** Bundled URL for a material's PNG, or undefined when no file exists. */
export function materialUrl(name: string): string | undefined {
  return materialUrls[`./totem-materials/${name}.png`];
}

/** Fetch + decode the PNG for every listed material. Fails fast on a
 *  material with no PNG — the spec and the image directory must agree
 *  (the totem-assets test and CI sync guard keep them that way). */
export async function loadMaterialImages(
  names: string[],
): Promise<Array<[string, ImageBitmap]>> {
  return Promise.all(
    names.map(async (name): Promise<[string, ImageBitmap]> => {
      const url = materialUrl(name);
      if (!url) {
        throw new Error(
          `totem material "${name}" has no PNG in src/map/totem-materials/`,
        );
      }
      const res = await fetch(url);
      if (!res.ok) {
        throw new Error(`totem material "${name}": fetch failed (${res.status})`);
      }
      return [name, await createImageBitmap(await res.blob())];
    }),
  );
}
